import { ScrollableCellWithAvatar } from '@/components/data-table/cells';
import { Label } from '@/components/ui/label';

import { InvoiceDetails } from '../../types';

interface InvoiceClientFieldProps {
  client: InvoiceDetails['client'];
  label: string;
}

/** Keeps the read-only client presentation consistent across invoice view and edit modes. */
export function InvoiceClientField({ client, label }: InvoiceClientFieldProps) {
  return (
    <Label className="flex flex-col items-stretch gap-2">
      <span>{label}</span>
      <div className="flex min-h-10 items-center rounded-md border border-input bg-muted px-3 py-1 text-sm">
        <ScrollableCellWithAvatar
          text={client.name}
          image={client.logoUrl}
          avatarName={client.name}
          avatarSize="sm"
          alt={`${client.name} logo`}
          withAvatarBorder
          className="w-full"
        />
      </div>
    </Label>
  );
}
